import React, {useState, useCallback, useEffect} from "react";
import { GoogleMap, LoadScript, Marker, Autocomplete } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "400px",
};

const center = {
    lat: 37.7749, // Default Latitude (San Francisco)
    lng: -122.4194, // Default Longitude
};



const MyMapComponent = () => {
    const [position, setPosition] = useState(center);
    const [autocomplete, setAutocomplete] = useState(null);
    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);
    // Marker'ı sürüklediğimizde tetiklenen fonksiyon
    const onMarkerDragEnd = (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        setPosition({ lat: newLat, lng: newLng });
        console.log("Yeni Pozisyon:", { lat: newLat, lng: newLng });
    };

    // Autocomplete'den seçilen yeri al
    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();
            const location = place.geometry.location;
            setPosition({
                lat: location.lat(),
                lng: location.lng(),
            });
        } else {
            console.log("Autocomplete yüklenmedi.");
        }
    };

    // Autocomplete bileşenini başlat
    const onLoadAutocomplete = useCallback((auto) => {
        setAutocomplete(auto);
    }, []);

    return (
        <LoadScript googleMapsApiKey="AIzaSyCPcyxFyRak0dBzXQz-fXejJ-VjfGFy8qs" libraries={["places"]}>
            <div style={{ marginBottom: "10px" }}>
                <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
                    <input
                        type="text"
                        placeholder="Bir yer arayın"
                        style={{ width: "300px", height: "40px", padding: "10px" }}
                    />
                </Autocomplete>
            </div>
            <GoogleMap mapContainerStyle={containerStyle} center={position} zoom={10}>
                <Marker
                    position={position}
                    draggable={true} // Marker sürüklenebilir
                    onDragEnd={onMarkerDragEnd}
                />
            </GoogleMap>
            <div style={{ marginTop: "10px" }}>
                <p>Latitude: {position.lat}</p>
                <p>Longitude: {position.lng}</p>
            </div>
        </LoadScript>
    );
};

export default MyMapComponent;